import styled from 'styled-components'

export const StyledTimeLabelContainer = styled.div`
  position: absolute;
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  padding-top: 30px;
  left: 0;
  right: 0;
`

export const StyledDot = styled.div.attrs<{
  $size: string
  $color: string
  $percentage: string
}>((props) => ({
  style: { left: `${props.$percentage}%` },
}))`
  position: absolute;
  height: ${({ $size }) => $size};
  width: ${({ $size }) => $size};
  background-color: ${({ $color }) => $color};
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  border-radius: 100%;
  transition: height 0.2s ease, width 0.2s ease;
`

export const StyledProgressBar = styled.div<{ $marginLeft?: number }>`
  position: relative;
  height: 40px;
  margin-left: ${({ $marginLeft }) => $marginLeft ?? 15}px;
  pointer-events: auto;
  width: 100%;
`

export const StyledLine = styled.div.attrs<{
  $height: string
  $color: string
  $fullWidth?: boolean
  $percentage?: string
}>((props) => ({
  style: { width: `${props.$fullWidth ? '100' : props.$percentage}%` },
}))`
  position: absolute;
  height: ${({ $height }) => $height};
  transition: height 0.2s ease;
  top: 50%;
  transform: translateY(-50%);
  background-color: ${({ $color }) => $color};
  max-width: 100%;
`
